import React, {Fragment,Component} from "react";
import axios from "axios";

class VcbBotoSalePerformanceRow extends Component{
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            apiDetail: '/api/bankportal/report/vcb/boto/salePerformance/detail/download',
            reportName: 'ReportBotoSalePerformance',
        }
        this.onCLickToExport = this.onCLickToExport.bind(this);
        this.handlerClickNode = this.props.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }

    onCLickToExport = (item) => {
        const payload = {
            yyyymmdd: item?.yyyymmdd,
            code: item?.code,
            type: item?.type,
            parentId: item?.parentId
        }
        const { apiDetail, reportName } = this.state;
        this.handlerSetIsLoading(true);
        axios.post(apiDetail, payload, {responseType: 'arraybuffer'})
            .then(response => {
                if(!!response.data){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    const exportName = item?.yyyymmdd+'_'+item?.code+'_'+item?.name+'_'+reportName+'.xlsx';
                    a.download = exportName;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }else{
                    console.log('Error when download file');
                }
                this.handlerSetIsLoading(false);
            })
            .catch(error => {
                this.setState({ errorMessage: error.message });
                console.error('There was an error!', error);
                this.handlerSetIsLoading(false);
            });
    }
    render() {
        const {hasChild,isExpanded,marginLeftValue,data} = this.props;
        const iconStyle = {
            marginLeft: marginLeftValue+'px',
            boxShadow: 'none'
        }
        return (
            <Fragment>
            {
                !!data &&
                <tr>
                    <td className={'bp-report-tree-node min-width-tree-node'}>
                        <button style={iconStyle} type="button" className={"btn"} onClick={this.handlerClickNode}>
                            {
                                hasChild ? isExpanded ? (' - ') : (' + ') : ('   ')
                            }
                        </button>
                        <span>{data?.name}</span>
                    </td>
                    <td className={"bp-report-td min-width-80"}><span> {data?.botoType?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.leadCount?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.leadCreated?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.leadHtKhRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.leadConvertRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypDailyReferral?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypDailyOnline?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypDailyCredit?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypMonthlyReferral?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypMonthlyOnline?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypMonthlyCredit?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypMonthlyAll?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypMonthlyHtKhRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypQuarterlyReferral?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypQuarterlyOnline?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypQuarterlyCredit?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypQuarterlyAll?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypQuarterlyHtKhRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypYearlyReferral?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypYearlyOnline?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypYearlyCredit?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypYearlyCarry?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypYearlyAll?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.fypYearlyHtKhRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.ipPending?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.caseNet?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.posTotal?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.posActive?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.posActiveRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.llbhTotal?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.llbhExitsCodeTotal?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.llbhExitsCodeRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.llbhActive?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.llbhActiveRatio?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.nsldFypPerCbbh?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.nsldCasecountPerCbbh?.toLocaleString()} </span></td>
                    <td className={"bp-report-td"}><span> {data?.nsldCasesize?.toLocaleString()} </span></td>
                    <td className={'bp-report-button-export'}>
                        <button onClick={() => this.onCLickToExport(data)} className={"btn btn-sm btn-info mt-1"}>Chi tiết</button>
                    </td>
                </tr>

            }
            </Fragment>
        )
    }
}

export default VcbBotoSalePerformanceRow;